import { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules"; // حذف Pagination
import { Link, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";

const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2.2}
    stroke="currentColor"
    className="w-3.5 h-3.5"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 4.5 3 12m0 0 7.5 7.5M3 12h18"
    />
  </svg>
);

// آیکون‌های SVG برای فلش‌ها
const PrevArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2.5}
    stroke="currentColor"
    className="w-5 h-5"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
);

const NextArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2.5}
    stroke="currentColor"
    className="w-5 h-5"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
);

const LocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.8}
    stroke="currentColor"
    className="w-3.5 h-3.5 opacity-70 shrink-0"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
    />
  </svg>
);

const CommentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.8}
    stroke="currentColor"
    className="w-3.5 h-3.5 opacity-70 text-gray-400"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
    />
  </svg>
);

const ShieldCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.8}
    stroke="currentColor"
    className="w-3.5 h-3.5 opacity-70 text-gray-400"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296a3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043a3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
    />
  </svg>
);

const DoctorsSwiperSection = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTopDoctors = async () => {
      try {
        const url = `https://medizenapi.ir/v1/doctor/getDoctors?page=1&count=10`;
        const res = await axios.get(url);
        if (res.data?.response_status === "success") {
          setDoctors(res.data.data || []);
        }
      } catch (error) {
        console.error("❌ Swiper Doctors API Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTopDoctors();
  }, []);

  if (loading) {
    return (
      <div className="w-full flex justify-center">
        <div className="w-10 h-10 border-4 border-purple border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <section className="w-full relative" dir="rtl">
      {/* هدر */}
      <div className="flex justify-center items-center mb-3 lg:mb-4 sm:px-2 max-sm:ml-5">
        <h3 className="flex items-center gap-4 w-full font-semibold text-[#383838]">
          <span className="flex-1 h-[2px] rounded-full bg-gradient-to-r from-purple/10 to-transparent"></span>
          <span className="flex items-center whitespace-nowrap px-2 text-[18px] md:text-[23px]">
            <span className="text-[#383838]">برترین</span>
            <span className="text-[#383838] mx-1.5">پزشکان</span>
          </span>
          <span className="flex-1 h-[2px] rounded-full bg-gradient-to-l from-purple/10 to-transparent"></span>
        </h3>
      </div>

      {/* Swiper Container */}
      <div className="relative group">
        <Swiper
          modules={[Navigation]}
          spaceBetween={2}
          slidesPerView={1.1}
          navigation={{
            nextEl: ".custom-next",
            prevEl: ".custom-prev",
          }}
          breakpoints={{
            480: { slidesPerView: 1.2 },
            640: { slidesPerView: 2 },
            900: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
          className="pb-6"
        >
          {doctors.map((doctor) => (
            <SwiperSlide key={doctor.id} className="!h-auto flex md:p-0.5">
              <div
                onClick={() => navigate(`/doctor/${doctor.id}`)}
                className="group relative overflow-hidden cursor-pointer rounded-[18px] 
                bg-white border border-gray-200 shadow-[0_0_10px_rgba(0,0,0,0.04)] 
                hover:shadow-[0_0_20px_rgba(0,0,0,.08)] hover:-translate-y-1 
                transition-all duration-500 m-1 flex flex-col h-full"
              >
                <div
                  className="absolute left-5 top-5 flex items-center gap-[2px] pt-[4px]
                 rounded-full bg-[#FFFCF3] border border-[#F5E7B7]/40 pr-1 pl-2 h-[22px] 
                 text-[10.5px] font-semibold text-yellow-600"
                >
                  ⭐<span className="text-[12.5px]">{doctor.score}</span>
                </div>

                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-4">
                    <div className="relative shrink-0">
                      <img
                        src={`https://bit.medizen.ir/i/${doctor.thumb}`}
                        alt={doctor.name}
                        className="w-[60px] h-[60px] rounded-[20px] object-cover border border-gray-100"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 line-clamp-1">
                        <h3
                          className="font-semibold text-[13px] md:text-[14px]
                         lg:text-[15px] text-[#222] truncate line-clamp-1 w-[70%]"
                        >
                          {doctor.name}
                        </h3>
                        {doctor.activity_status === "active" && (
                          <span
                            className="w-2.5 h-2.5 rounded-full bg-green-500 z-50
                          shadow-[0_0_10px_rgba(34,197,94,.5)]"
                          />
                        )}
                      </div>
                      <p
                        className="text-[11px] md:text-[12px]
                         lg:text-[12px] text-gray-600 mt-1 line-clamp-1"
                      >
                        {doctor.title}
                      </p>
                    </div>
                  </div>

                  <div className="mt-5 flex items-start gap-2 text-gray-500/80 min-h-[46px]">
                    <div className="mt-1 shrink-0">
                      <LocationIcon />
                    </div>
                    <span
                      className="text-[11px] lg:text-[12px] leading-[22px] 
                    line-clamp-2 min-h-[45px]"
                    >
                      {doctor.address || "آدرس ثبت نشده است"}
                    </span>
                  </div>

                  <div className="mt-3 rounded-2xl border border-[#EEF2F7] bg-[#FAFBFD] pt-[2px] pb-2 flex items-center justify-between">
                    <div className="flex-1 flex flex-col items-center justify-center">
                      <span className="text-[16px] font-medium text-gray-700">
                        {doctor.count}
                      </span>
                      <div className="flex items-center gap-1.5 text-gray-500">
                        <CommentIcon />
                        <span className="text-[11px] text-gray-500/80">
                          نظر
                        </span>
                      </div>
                    </div>
                    <div className="w-[1px] h-6 bg-gray-200"></div>
                    <div className="flex-1 flex flex-col items-center justify-center">
                      <span className="text-[16px] font-medium text-gray-700">
                        {doctor.count}
                      </span>
                      <div className="flex items-center gap-1.5 text-gray-500">
                        <ShieldCheckIcon />
                        <span className="text-[11px] text-gray-500/80">
                          نوبت موفق
                        </span>
                      </div>
                    </div>
                  </div>

                  <button
                    className="mt-3 h-[40px] md:h-[44px] rounded-[14px] bg-[#49D1CD] -mb-1
                  text-white font-medium text-[13px] md:text-[14px] transition-all duration-300 hover:bg-[#35beb9] hover:shadow-lg active:scale-[.98]"
                  >
                    دریافت نوبت
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* فلش‌های نویگیشن با قابلیت کمرنگ شدن (Disabled) */}
        <div className="custom-prev absolute top-1/2 -right-4 z-20 hidden md:flex translate-y-[-50%] w-10 h-10 items-center justify-center rounded-full bg-white border border-gray-200 text-gray-600 cursor-pointer shadow-lg hover:text-[#49D1CD] transition-all [&.swiper-button-disabled]:opacity-30 [&.swiper-button-disabled]:cursor-not-allowed">
          <PrevArrow />
        </div>
        <div className="custom-next absolute top-1/2 -left-4 z-20 hidden md:flex translate-y-[-50%] w-10 h-10 items-center justify-center rounded-full bg-white border border-gray-200 text-gray-600 cursor-pointer shadow-lg hover:text-[#49D1CD] transition-all [&.swiper-button-disabled]:opacity-30 [&.swiper-button-disabled]:cursor-not-allowed">
          <NextArrow />
        </div>
      </div>

      <div className="text-center items-center justify-center flex duration-300 mt-4 lg:mt-6">
        <Link
          to="/doctors"
          className="
                  flex
                  items-center
                  gap-1.5
                  text-purple
                  text-[12px]
                  font-medium
                  hover:gap-3
                  transition-all
                  "
        >
          مشاهده همه
          <ArrowIcon />
        </Link>
      </div>
    </section>
  );
};

export default DoctorsSwiperSection;
